module.exports = __webpack_public_path__ + "static/media/org_fax.557f2ee6.svg";